import React from "react";
import MerchantBlackList from "modules/merchantBlackList";

const MerchantBlackListPage = () => {
  return <MerchantBlackList />;
};

export default MerchantBlackListPage;
